export const VIEW_KEYS = new Set(['panX', 'panY', 'zoom'])
export const RUNTIME_ITEM_KEYS = new Set([
  '_videoEl', '_videoTimeUpdateHandler', '_videoMountGen', '_loading', '_pendingFullUpgrade',
  '_modelFrames', '_jobId', '_boardPending', '_boardStartTs', '_gifGen', '_gifSkip',
])
export const ASSET_URI_RE = /^asset:\/\/([0-9a-f]{16})\.([A-Za-z0-9]+)$/

export function stripViewport(document) {
  const output = {}
  for (const [key, value] of Object.entries(document || {})) if (!VIEW_KEYS.has(key)) output[key] = value
  return output
}

export function stripRuntimeFields(document) {
  const source = structuredClone(document || {})
  source.items = Array.isArray(source.items) ? source.items.filter(item => !item?._loading).map(item => {
    for (const key of RUNTIME_ITEM_KEYS) delete item[key]
    return item
  }) : []
  return source
}

export function normalizeDocument(id, value, existing = null) {
  const source = value && typeof value === 'object' ? stripRuntimeFields(value) : {}
  return {
    ...(existing || {}), ...source, id,
    name: String(source.name || existing?.name || 'Untitled'),
    items: Array.isArray(source.items) ? source.items : [],
    createdAt: Number(existing?.createdAt || source.createdAt) || Date.now(),
  }
}

export function scanAssetUris(value) {
  const found = new Map()
  const visit = current => {
    if (typeof current === 'string') {
      const match = ASSET_URI_RE.exec(current)
      if (match) found.set(current, { uri: current, hash: match[1], ext: match[2].toLowerCase() })
      return
    }
    if (Array.isArray(current)) { current.forEach(visit); return }
    if (current && typeof current === 'object') Object.values(current).forEach(visit)
  }
  visit(value)
  return [...found.values()]
}

export function mergeView(document, view) {
  return { ...document, panX: Number(view?.panX) || 0, panY: Number(view?.panY) || 0, zoom: Number(view?.zoom) || 1 }
}
